/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseActionExecuteRequest,
  ResponseActionPreviewRequest,
} from '../models/index';
import {
    ResponseActionExecuteRequestFromJSON,
    ResponseActionExecuteRequestToJSON,
    ResponseActionPreviewRequestFromJSON,
    ResponseActionPreviewRequestToJSON,
} from '../models/index';

export interface ExecuteRequest {
    sessionId: string;
    responseActionExecuteRequest: ResponseActionExecuteRequest;
}

export interface GetCatalogRequest {
    sessionId: string;
    contextEntityType: string;
    contextEntityId: string;
}

export interface PreviewRequest {
    sessionId: string;
    responseActionPreviewRequest: ResponseActionPreviewRequest;
}

/**
 * ResponseActionsApi - interface
 * 
 * @export
 * @interface ResponseActionsApiInterface
 */
export interface ResponseActionsApiInterface {
    /**
     * 
     * @summary Execute response action
     * @param {string} sessionId 
     * @param {ResponseActionExecuteRequest} responseActionExecuteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResponseActionsApiInterface
     */
    executeRaw(requestParameters: ExecuteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Execute response action
     */
    execute(requestParameters: ExecuteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists remediation actions available for a CASE_ENTITY or ASSET_GOLDEN context, filtered by source technology, deployed integrations, entitlements, and resolvable invoke parameters.
     * @summary Response action catalog
     * @param {string} sessionId 
     * @param {string} contextEntityType 
     * @param {string} contextEntityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResponseActionsApiInterface
     */
    getCatalogRaw(requestParameters: GetCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists remediation actions available for a CASE_ENTITY or ASSET_GOLDEN context, filtered by source technology, deployed integrations, entitlements, and resolvable invoke parameters.
     * Response action catalog
     */
    getCatalog(requestParameters: GetCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Preview response action
     * @param {string} sessionId 
     * @param {ResponseActionPreviewRequest} responseActionPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResponseActionsApiInterface
     */
    previewRaw(requestParameters: PreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Preview response action
     */
    preview(requestParameters: PreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class ResponseActionsApi extends runtime.BaseAPI implements ResponseActionsApiInterface {

    /**
     * Execute response action
     */
    async executeRaw(requestParameters: ExecuteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling execute().'
            );
        }

        if (requestParameters['responseActionExecuteRequest'] == null) {
            throw new runtime.RequiredError(
                'responseActionExecuteRequest',
                'Required parameter "responseActionExecuteRequest" was null or undefined when calling execute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/response-actions/execute`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResponseActionExecuteRequestToJSON(requestParameters['responseActionExecuteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Execute response action
     */
    async execute(requestParameters: ExecuteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.executeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists remediation actions available for a CASE_ENTITY or ASSET_GOLDEN context, filtered by source technology, deployed integrations, entitlements, and resolvable invoke parameters.
     * Response action catalog
     */
    async getCatalogRaw(requestParameters: GetCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getCatalog().'
            );
        }

        if (requestParameters['contextEntityType'] == null) {
            throw new runtime.RequiredError(
                'contextEntityType',
                'Required parameter "contextEntityType" was null or undefined when calling getCatalog().'
            );
        }

        if (requestParameters['contextEntityId'] == null) {
            throw new runtime.RequiredError(
                'contextEntityId',
                'Required parameter "contextEntityId" was null or undefined when calling getCatalog().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['contextEntityType'] != null) {
            queryParameters['contextEntityType'] = requestParameters['contextEntityType'];
        }

        if (requestParameters['contextEntityId'] != null) {
            queryParameters['contextEntityId'] = requestParameters['contextEntityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/response-actions/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists remediation actions available for a CASE_ENTITY or ASSET_GOLDEN context, filtered by source technology, deployed integrations, entitlements, and resolvable invoke parameters.
     * Response action catalog
     */
    async getCatalog(requestParameters: GetCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCatalogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview response action
     */
    async previewRaw(requestParameters: PreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling preview().'
            );
        }

        if (requestParameters['responseActionPreviewRequest'] == null) {
            throw new runtime.RequiredError(
                'responseActionPreviewRequest',
                'Required parameter "responseActionPreviewRequest" was null or undefined when calling preview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/response-actions/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResponseActionPreviewRequestToJSON(requestParameters['responseActionPreviewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Preview response action
     */
    async preview(requestParameters: PreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.previewRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
